import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebaar from "../Component/Sidebar";
import userimage from "../assets/images/user.png";
import banner from "../assets/images/banner.jpg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";
import approvedimg from '../assets/images/approved.png'
import rejected from '../assets/images/rejected.png'


function Userdetail() {
  const { state } = useLocation();
  let token = localStorage.getItem("token");
  const navigate = useNavigate()
  const [loading, setloading] = useState(false);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [data, setdata] = useState(state);
  console.log("data", data);

  const Rejected = (e) => {
    e.preventDefault();

  };


  const resetDevice = () => {
    let requestdata = {
      _id: data._id
    }
    axios.post(`${Base_Url}/reset_device`, requestdata, { headers }).then((res) => {
      if (res.data.message == "Ok") {
        toast.success("Reset Device Succesfully")
      }
    }).catch((err) => {
      toast.error("Device not reset")
    })
  }

  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const Approved = (e) => {
    e.preventDefault();
    notify("Approved", "success");
  };

  const handleKyc = (e, name) => {
    e.preventDefault();
    setloading(true)
    // let requestdata = {
    //   _id: data._id,
    //   kyc_status: name,
    // };

    let formdata = new FormData()

    formdata.append("_id", data._id)
    formdata.append("kyc_status", name)


    axios.put(`${Base_Url}/users`, formdata, { headers }).then((res) => {
      console.log(res)
      if (res.data) {
        if (name == false) {
          notify("Rejected", "success");
          setTimeout(() => {
            navigate('/user')
          }, 1500);
        } else {
          notify("Approved", "success");
          setTimeout(() => {
            navigate('/user')
          }, 1500);
        }
      }
    }).finally(() => {
      setloading(false)
    })
  };

  return (
    <>
      <Sidebaar
        content={
          <>
            {loading && (
              <div className="overlay">
                <Bars
                  height="80"
                  width="80"
                  color="#051322"
                  ariaLabel="bars-loading"
                  visible={true}
                />
              </div>
            )}
            <div
              className="col-md-12 p-0"
              style={{ position: "relative", bottom: "50px" }}
            >
              <img
                src={banner}
                className="img-fluid w-100"
                style={{ height: "300px" }}
                alt=""
              />
            </div>

            <div className="row align-items-center justify-content-center">
              <div
                className="col-md-11"
                style={{ position: "relative", bottom: "70px" }}
              >
                <div className="row bg-white shadow rounded-4">
                  <div className="col-md-2">
                    <div
                      className="m-2  rounded-5 bg-white shadow p-1 relative bottom-14"
                      style={{ width: "max-content" }}
                    >
                      <div className="bg-slate-300 p-3 rounded-5">
                        <img
                          src={`${Base_Url}/${data.shop_image}`}
                          onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop in case the error image also fails to load
                            e.target.src = `${userimage}`; // replace with your error image URL
                          }}
                          className="h-24"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mt-3">
                      {data.country && (
                        <h6
                          className="text-base  rounded-lg mt-2 bg-cyan-100 px-3 capitalize"
                          style={{ width: "max-content " }}
                        >
                          {data.state} , {data.pincode} , {data.country}
                        </h6>
                      )}
                      <div className="ps-3 mt-2">
                        <h3 className="text-4xl capitalize">{data.name}</h3>
                      </div>
                      <div className="ps-3 mt-2 d-flex align-items-center gap-2">
                        <h3 className="text-6md capitalize">Kyc Status :</h3>
                        {data.kyc_status ? <img src={approvedimg} className="img-fluid" width={50} /> : <img src={rejected} className="img-fluid" width={50} />}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mt-4 grid gap-x-8 gap-y-4 grid-cols-2">
                      <button onClick={(e) => resetDevice(e)} className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded text-base">Reset Device</button>
                      <button
                        className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded text-base"
                        onClick={(e) => handleKyc(e, false)}
                      >
                        Rejected
                      </button>
                      <button
                        className="bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded text-base"
                        onClick={(e) => handleKyc(e, true)}
                      >
                        Approved
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-11">
                <div className="row informationbox">
                  {(data.name || data.gender || data.email || data.phone || data.shop_name) && <div className="col-md-6">
                    <div className="shadow bg-white rounded-md">
                      <div className="bg-stone-200 p-3 rounded-md">
                        <h2 className="text-3xl  font-normal">
                          User Information
                        </h2>
                      </div>
                      <div className="p-3">
                        {data.name && <div className="mb-4 grid grid-cols-2 gap-2 ">
                          <h3 className="font-medium text-md">Name</h3>
                          <h4>{data.name}</h4>
                        </div>}
                        {data.gender && <div className="mb-4 grid grid-cols-2 gap-2">
                          <h3 className="font-medium text-md">Gender</h3>
                          <h4>{data.gender}</h4>
                        </div>}
                        {data.email && <div className="mb-4 grid grid-cols-2 gap-2">
                          <h3 className="font-medium text-md">Email</h3>
                          <h4>{data.email}</h4>
                        </div>}
                        {data.phone && <div className="mb-4 grid grid-cols-2 gap-2">
                          <h3 className="font-medium text-md">Phone</h3>
                          <h4>{data.phone}</h4>
                        </div>}
                        {data.shopname && <div className="mb-4 grid grid-cols-2 gap-2">
                          <h3 className="font-medium text-md">Shop Name</h3>
                          <h4>{data.shop_name}</h4>
                        </div>}
                      </div>
                    </div>
                  </div>}
                  {
                    (data.city || data.address || data.state || data.pincode || data.country) && <div className="col-md-6">
                      <div className="shadow bg-white rounded-md">
                        <div className="bg-stone-200 p-3 rounded-md">
                          <h2 className="text-3xl  font-normal">User Address</h2>
                        </div>
                        <div className="p-3">
                          {data.city && <div className="mb-4 grid grid-cols-2 gap-2">
                            <h3 className="font-medium text-md">City</h3>
                            <h4>{data.city}</h4>
                          </div>}
                          {data.address && <div className="mb-4 grid grid-cols-2 gap-2">
                            <h3 className="font-medium text-md">Address</h3>
                            <h4>{data.address}</h4>
                          </div>}
                          {data.state && <div className="mb-4 grid grid-cols-2 gap-2">
                            <h3 className="font-medium text-md">State</h3>
                            <h4>{data.state}</h4>
                          </div>}
                          {data.pincode && <div className="mb-4 grid grid-cols-2 gap-2">
                            <h3 className="font-medium text-md">Pincode</h3>
                            <h4>{data.pincode}</h4>
                          </div>}
                          {data.country && <div className="mb-4 grid grid-cols-2 gap-2">
                            <h3 className="font-medium text-md">Country</h3>
                            <h4>{data.country}</h4>
                          </div>}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <ToastContainer />
          </>
        }
      />
    </>
  );
}

export default Userdetail;

// const notify = (message, type) => {
//   const backgroundColor = type === "success" ? "green" : "red";

//   toast[type](message, {
//     autoClose: 3000,
//     hideProgressBar: false,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//     style: {
//       background: backgroundColor,
//     },
//   });
// };
